import React, { useState, useEffect } from 'react'
import moment from 'moment-jalaali'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Paper from '@material-ui/core/Paper'
import Tab from '@material-ui/core/Tab'
import { debounce } from 'lodash'
import { getMuiThemeWithoutPadding } from '../../utils/TableStyle'
import { getTicketsByStatus, getTickets } from '../../app/slices/ticketsSlice'
import muiDefaultOptions from '../../constants/muiTableOptions'

const STATUS = {
  100: 'جدید',
  110: 'در حال بررسی',
  115: 'بسته شده',
}

const useStyle = makeStyles(() => ({
  linkButton: {
    marginBottom: 10,
  },
  status0: {
    color: '#009fff',
  },
  status1: {
    color: '#ff008c',
  },
  status2: {
    color: '#25d423',
  },
  status3: {
    color: '#00000059',
  },
  tabPaper: {
    marginBottom: 10,
  },
}))

export const TicketList = ({ isUser = false }) => {
  const classes = useStyle()
  const [tabIndex, setTabIndex] = useState(0)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const tickets = useSelector((state) => state?.tickets?.list)
  const count = useSelector((state) => state.notifications.totalHits)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)
  const [searchText, setSearchText] = useState()

  console.log(tickets)

  const updateSearch = debounce((text) => {
    setSearchText(text)
  }, 500, { maxWait: 1000 })

  useEffect(() => {
    const defaultOption = {
      after: page * rowsPerPage,
      first: rowsPerPage,
    }
    if (searchText && !isUser) defaultOption.userName = searchText

    if (!isUser) {
      switch (tabIndex) {
        case 0:
          dispatch(getTicketsByStatus({ status: 100, ...defaultOption }))
          break
        case 1:
          dispatch(getTicketsByStatus({ status: 110, ...defaultOption }))
          break
        case 2:
          dispatch(getTicketsByStatus({ status: 115, ...defaultOption }))
          break
        default:
          dispatch(getTicketsByStatus({ status: 100, ...defaultOption }))
      }
    } else {
      dispatch(getTickets(defaultOption))
    }
  }, [tabIndex, page, rowsPerPage, searchText])

  const COLUMNS = [
    {
      name: 'createDate',
      label: 'ردیف',
      options: {
        customBodyRender: (value) => {
          const index = tickets?.findIndex((ticket) => ticket?.createDate === value)
          return (
            <p>{index + 1}</p>
          )
        },
      },
    },
    {
      name: 'owner',
      label: 'کد ملی',
      options: {
        customBodyRender: (value) => {
          if (value.firstName && value.lastName) return `${value.firstName} ${value.lastName}`
          return value.userName
        },
      },
    },
    {
      name: 'question',
      label: 'عنوان',
    },
    {
      name: 'status',
      label: 'وضعیت',
      options: {
        customBodyRender: (value) => (
          <p className={classes[`status${value}`]}>{STATUS[value]}</p>
        ),
      },
    },
    {
      name: 'id',
      label: 'شماره پیگیری مکالمه',
    },
    {
      name: 'createDate',
      label: 'تاریخ ایجاد',
      options: {
        customBodyRender: (value) => (value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'),
      },
    }, {
      name: 'lastUpdateDate',
      label: 'آخرین بروزرسانی',
      options: {
        customBodyRender: (value) => (value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'),
      },
    },
  ]
  const columns = React.useMemo(() => {
    return !isUser ? COLUMNS : [...COLUMNS.slice(1, COLUMNS.length)]
  }, [COLUMNS])

  const handleSelectedRow = (rowData) => {
    const idIndex = columns.findIndex((item) => item.name === 'id')
    console.log(idIndex)
    const selectedTicket = tickets.find((item) => item.id === rowData[idIndex])
    navigate(`./${selectedTicket.id}`, { state: selectedTicket })
  }

  const handleTabChage = (event, newValue) => {
    setTabIndex(newValue)
  }

  return (
    <>
      {!isUser && (
      <Paper className={classes.tabPaper}>
        <Tabs
          value={tabIndex}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleTabChage}
          aria-label="disabled tabs example"
        >
          <Tab label="تیکت‌های جدید" />
          <Tab label="تیکت‌های باز" />
          <Tab label="تیکت‌های بسته" />
        </Tabs>
      </Paper>
      )}
      <ThemeProvider theme={getMuiThemeWithoutPadding}>
        <MUIDataTable
          data={tickets}
          columns={columns}
          options={{
            ...muiDefaultOptions,

            rowsPerPage,
            page,
            count,

            serverSide: true,
            filter: false,
            print: false,
            download: false,
            search: !isUser,

            selectableRows: 'none',
            rowHover: true,
            onTableChange: (action, state) => {
              switch (action) {
                case 'changePage': {
                  setPage(state.page)
                  break
                }
                case 'changeRowsPerPage': {
                  setRowsPerPage(state.rowsPerPage)
                  break
                }
                case 'search': {
                  updateSearch(state.searchText)
                  break
                }
                default:
                  break
              }
            },
            onRowClick: handleSelectedRow,
          }}
        />
      </ThemeProvider>
    </>
  )
}

TicketList.prototype = {
  tickets: PropTypes.array,
  setSelectedTicket: PropTypes.func,
  isUser: PropTypes.bool,
}

export default TicketList
